<template>
    <div class="container-fluid position-relative bg-BAT">
        <loading v-if="loading !== 0"></loading>
        <div>
            <div class="container watch-container py-4">
                <div>
                    <div class="breadcrumbs-retos d-flex flex-column pb-2">
                        <div>
                            <a href="/home-bat">
                                <img src="/img/icons/homeBread.svg" alt="" />
                                Home
                            </a>
                            <a id="practica" class="link cursor-pointer link-active-bread"
                                href="/home-bat">Solicitudes de Staff</a>
                            <span id="optionP" class="d-none color-active-miga"></span>
                        </div>
                    </div>
                    <a class="pb-2 pt-2" href="/home-bat"><img src="/img/icons/regresar.svg" alt="icon"></a>
                </div>
            </div>

            <div class="container mt-3">
                <div>
                    <div class="col-12 col-md-6">
                        <div class="header-portfolio d-flex flex-column">
                            <h5 class="text-title-bat mb-2">Staff</h5>
                            <el-alert v-if="showAlert" class="custom-alert" type="warning" show-icon style="position: fixed; top: 107px; right: 8%; z-index: 2000; border: 1px solid #FFBA01; background-color: #FEFFE3; border-radius: 8px;">
                                <div class="text-black">
                                    <strong>Tienes solicitudes pendientes por revisión. </strong>  Si no se gestionan, serán rechazadas de manera automática..
                                </div>
                            </el-alert>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-6 ">
                            <div>
                                <!-- Filtros -->
                                <div class="row mt-4 mt-md-4 mb-2 mb-md-4 justify-content-between">
                                    <el-select v-model="value" filterable placeholder="Filtrar solicitudes">
                                        <el-option v-if="uniquePDVNames.length > 1" :label="'Ver todas'" :value="null"></el-option>
                                        <el-option v-for="name in uniquePDVNames"  :key="name" :label="formatName(name)"
                                            :value="formatName(name)">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-center">
                        <div v-if="paginatedData.length === 0" class="col-12 text-center my-5 container-fluid py-5 no-found">
                            <img src="/img-version2/icons/staff/sin-solicitudes.png" alt="no found">
                            <span>Aún no hay solicitudes pendientes</span>
                        </div>


                        <div v-for="(item, pdvIndex) in paginatedData" :key="item.id" class="col-lg-4 col-md-6 col-12 my-3">
                            <div class="card-Requests-staff-manager px-3 py-3">
                                <div class="content">
                                    <div class="mb-3">
                                        <!-- <p class="mb-2">Solicitud nuevo usuario <br> -->
                                        <p class="mb-2">{{ item.request == 'associate' ? 'Solicitud de vinculación' : 'Solicitud nuevo usuario' }} <br>
                                            <span><strong class="text-indigo">{{ item.pdv.insitu_code }}</strong></span>
                                        </p>
                                        <h6 class="name-h6">{{ formatName(item.pdv.name_pdv) }}</h6>

                                        <p class="name-h6 mb-2"><strong>Nombre:</strong>
                                            <span v-if="item.name">
                                                {{ formatName(item.name) }}
                                            </span>
                                            <span v-else>No disponible</span>
                                        </p>
                                        <p class="name-h6 mb-2"><strong>Total cupos:</strong> {{ item.pdv.places || 'No disponible' }}</p>
                                        <p class="name-h6 mb-2"><strong>Cupos disponibles:</strong> {{ item.available_places || 'No disponible' }}</p>
                                        <span class="mb-2 rounded-5 border border-info text-info px-2 py-1 text-btn-outstanding">
                                            <img class="mx-1" src="/img/icons/clock_win_points.svg" alt="vencimiento">
                                            Vence en {{ calculateRemainingDays(item.created_at) }} días
                                        </span>
                                        <p class="name-h6 mb-2" v-if="item.available_places === 0 ">Los cupos mostrados consideran las solicitudes
                                            en trámite. </p>
                                    </div>
                                </div>
                                <span slot="footer" class="dialog-footer text-bat">
                                    <div class="row">
                                        <div class="col-6">
                                            <el-button class="w-full btnBlue w-100 p-3 btn-popups text-title-bat" @click="openRejectedModal(item)">Rechazar</el-button>
                                        </div>
                                        <div class="col-6">
                                            <el-button class="w-full btnBlue w-100 p-3 btnBlue text-title-bat" @click="openConfirmationModal(item)">Aprobar</el-button>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Modal de confirmación -->
                    <el-dialog :visible.sync="confirmationModal" :width="getWidth()" class="dialog-mobile"
                        :close-on-click-modal="true" :close-on-press-escape="true" :show-close="true">
                        <div class="modals">
                            <h6 class="mx-auto" style="width: auto!important; max-width: 268px!important;">¿Confirmas la
                                aprobación de la solicitud de activación para el usuario {{ selectedRequestStaff?.name }}?</h6>
                            <div class="d-flex align-items-center flex-column justify-content-center px-0">
                                <div>
                                    <div class="col-6" style="padding: 10px 0!important;">
                                        <div class="buttonTwo" type="buttoYes" @click="approveRequest">Aceptar
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="text-more cursor-pointer buttonOne" @click="confirmationModal = false" type="buttoNot">Cancelar</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-dialog>

                    <!-- Modal de confirmación para rechazo -->
                    <el-dialog :visible.sync="modalMonfirmationRejected" :width="getWidth()" class="dialog-mobile"
                        :close-on-click-modal="true" :close-on-press-escape="true" :show-close="true">
                        <div class="modals">
                            <h6 class="mx-auto" style="width: auto!important; max-width: 268px!important;">¿Estás seguro
                                que deseas rechazar la solicitud de activación para el usuario
                                {{ selectedRequestStaff?.name }}?</h6>
                            <div class="d-flex align-items-center flex-column justify-content-center px-0">
                                <div>
                                    <div class="col-6" style="padding: 10px 0!important;">
                                        <div class="buttonTwo" type="buttoYes" @click="rejectRequest">
                                            Aceptar
                                        </div>
                                    </div>
                                    <div class="col-6" style="padding: 10px 0!important;">
                                        <div class="text-more cursor-pointer buttonOne" @click="modalMonfirmationRejected = false" type="buttoNot">Cancelar</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-dialog>

                    <!-- Modal exitoso -->
                    <el-alert
                        v-if="successFulModal"
                        :title="`Has aprobado la solicitud de activación del usuario: ${selectedRequestStaff.name}`"
                        type="success"
                        show-icon
                        style="position: fixed; top: 20px; right: 20px; z-index: 2000; width: 300px;">
                    </el-alert>


                    <!-- Modal exitoso de rechazo -->
                    <el-alert
                        v-if="modalSuccessFulToReject"
                        :title="`Has rechazado la solicitud de activación del usuario: ${selectedRequestStaff.name}`"
                        type="error alert"
                        show-icon
                        style="position: fixed; top: 20px; right: 20px; z-index: 2000; width: 300px;">
                    </el-alert>

                    <!-- Modal opciones de rechazado -->
                    <el-dialog :visible.sync="modalRejected" width="400px" class="filterDialogCatalog" >
                        <div class="modal-content">
                        <h6 class="modal-title">
                            <strong>Selecciona el motivo del rechazo para la solicitud de usuario staff {{ selectedRequestStaff?.name }}.</strong>
                        </h6>

                        <el-radio-group v-model="orderFilterPointsOption" class="radio-group-request-staff">
                            <div class="d-flex flex-column w-100">
                                <el-radio :label="4" class="mb-3">Documentación no válida o faltante</el-radio>
                                <el-radio :label="5" class="mb-3">Solicitud fuera del proceso establecido</el-radio>
                                <el-radio :label="6" class="mb-3">Inconsistencias en los datos personales</el-radio>
                                <el-radio :label="7" class="mb-3">Otra</el-radio>
                            </div>
                        </el-radio-group>

                        <el-input
                            v-if="orderFilterPointsOption === 7"
                            v-model="otherReason"
                            placeholder="Escribe el motivo..."
                            maxlength="300"
                            show-word-limit
                            type="textarea"
                            class="text-area"
                            style="border-color: black !important; border-width: 1px !important">

                        </el-input>

                        <div>
                            <div class="col-12" style="padding: 10px 0!important;">
                                <div class="buttonTwo" type="buttoYes" @click="showConfirmationAndHideRejected">
                                    Continuar
                                </div>
                            </div>
                            <div class="col-12" style="padding: 10px 0!important;">
                                <div class="text-more cursor-pointer buttonOne" type="buttoNot" @click="modalRejected = false">Cancelar</div>
                            </div>
                        </div>
                        </div>
                    </el-dialog>
                </div>
            </div>

            <div class="row justify-content-center" v-if="totalPages > 1">
                <div class="d-flex align-items-center justify-content-center">
                    <button @click="goToPage(currentPage - 1)" class="bg-transparent border-0" :disabled="currentPage === 1">
                        &lt;
                    </button>
                    <div class="text-bat">
                        <div v-if="visiblePages.length > 0">
                            <span v-if="visiblePages[0] > 1">...</span>
                            <span
                                v-for="page in visiblePages"
                                :key="page"
                                @click="goToPage(page)"
                                class="mx-3 mx-md-4 cursor-pointer"
                                :class="{ 'text-title-bat text-orange': page === currentPage }">
                                        {{ page }}
                                    </span>
                            <span v-if="visiblePages[visiblePages.length - 1] < totalPages">...</span>
                        </div>
                    </div>
                    <button @click="goToPage(currentPage + 1)" class="bg-transparent border-0"  :disabled="currentPage  === totalPages  || totalPages  === 0">
                        &gt;
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { EventBus } from './../../app';
export default {
    props: {

    },
    data() {
        return {
            loading: 0,
            orderFilterPointsOption: null,
            confirmationModal: false,
            successFulModal: false,
            modalRejected: false,
            modalSuccessFulToReject: false,
            modalMonfirmationRejected: false,

            pdvs: [],
            pdv: {},
            request_clients: [],
            identification: '',
            selectedRequestStaff: null,
            getWidth() {
                if (this.$mq === 'sm') {
                    return '95%';
                } else if (this.$mq === 'md') {
                    return '35%';
                } else if (this.$mq === 'lg') {
                    return '30%';
                } else {
                    return '20%';
                }
            },
            value: '',
            pageSelected: 1,
            pageSize: 6,
            requestStaffList: [],
            otherReason: '',
            reject_reason: '',
            rejectReasons: {
                4: "Documentación no válida o faltante",
                5: "Solicitud fuera del proceso establecido",
                6: "Inconsistencias en los datos personales",
                7: "Otra"
            },
            currentPage: 1,
            itemsPerPage: 15,
            maxVisiblePages: 5,
            showAlert: false,
        }
    },
    computed: {
        filteredPDVs() {
            if (!this.value) {
                return this.pdvs;
            }

            return this.pdvs.filter(item => {
                return item.pdv.name_pdv.toLowerCase().includes(this.value.toLowerCase());
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredPDVs.slice(start, end);
        },
        visiblePages() {
            const pages = [];
            const half = Math.floor(this.maxVisiblePages / 2);
            let start = Math.max(1, this.currentPage - half);
            let end = Math.min(this.totalPages, start + this.maxVisiblePages - 1);

            if (end - start < this.maxVisiblePages - 1) {
                start = Math.max(1, end - this.maxVisiblePages + 1);
            }

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            return pages;
        },
        totalPages() {
            return Math.ceil(this.filteredPDVs.length / this.itemsPerPage);
        },
        uniquePDVNames() {
            const uniqueNames = new Set(this.pdvs.map(item => item.pdv.name_pdv));

            return Array.from(uniqueNames);
        }
    },

    mounted() {
        this.loadPDVsWithUsers();
    },

    methods: {
        loadPDVsWithUsers() {
            this.loading++;
            axios.get(`/get-pdvs-with-users-request?page=${this.currentPage}`)
                .then(({ data }) => {
                    const requestStaffData = data.request_staff;
                    if (requestStaffData && Array.isArray(requestStaffData)) {
                        if(requestStaffData.length > 0){
                            this.showAlertWarning();
                        }
                        this.pdvs = requestStaffData.map(item => {
                            if (!item.pdv.admins) {
                                item.pdv.admins = [];
                            }
                            const createdAt = item.created_at;
                            const updatedAt = item.updated_at;
                            return {
                                id: item.id,
                                pdv: item.pdv,
                                name: item.name,
                                insitu_code: item.insitu_code,
                                request: item.request,
                                status: item.status,
                                created_at: createdAt,
                                updated_at: updatedAt,
                                available_places: item.available_places
                            };
                        });
                    } else {
                        console.error("La respuesta no contiene un array válido de PDVs.");
                        this.pdvs = [];
                    }
                    this.loading--;
                })
                .catch(error => {
                    console.error("Error al cargar los PDVs con usuarios:", error);
                    this.pdvs = [];
                    this.loading--;
                });
        },


        openConfirmationModal(requestStaff) {
            this.selectedRequestStaff = requestStaff;
            this.confirmationModal = true;
        },


        openRejectedModal(requestStaff) {
            this.orderFilterPointsOption = null;
            this.otherReason = '';
            this.selectedRequestStaff = requestStaff;
            this.modalRejected = true;
        },

        approveRequest() {
            if (this.selectedRequestStaff) {
                const requestStaffData = {
                    insitu_code: this.selectedRequestStaff.pdv.insitu_code,
                };
                axios.post(`/approve-request-user-pdv/${this.selectedRequestStaff.id}`, requestStaffData)
                    .then(response => {
                        this.loadPDVsWithUsers();
                        this.successFulModal = true;
                        setTimeout(() => {
                            this.successFulModal = false;
                            EventBus.$emit('refresh-request', { })
                            }, 5000);
                        this.confirmationModal = false;
                    })
                    .catch(error => {
                        console.error('Error al aprobar la solicitud:', error);
                    });
            }
        },

        rejectRequest() {
            if (this.selectedRequestStaff) {
                this.loading++;
                let rejectReason = this.reject_reason;

                if (this.orderFilterPointsOption === 7) {
                    rejectReason = this.otherReason;
                } else {
                    rejectReason = this.rejectReasons[this.orderFilterPointsOption];
                }

                axios.post(`/reject-request-user-pdv/${this.selectedRequestStaff.id}`, {
                    reject_reason: rejectReason
                })
                    .then(response => {
                        this.loading--;
                        this.modalSuccessFulToReject = true;
                        this.modalMonfirmationRejected = false;
                        this.modalRejected = false;
                        this.loadPDVsWithUsers();
                        setTimeout(() => {
                            this.modalSuccessFulToReject = false;
                            EventBus.$emit('refresh-request', { });
                        }, 5000);
                    })
                    .catch(error => {
                        console.error("Error al rechazar solicitud:", error);
                        this.loading--;
                    });
            } else {
                console.error("No se han proporcionado datos válidos para el PDV o el cliente.");
            }
        },

        showConfirmationAndHideRejected() {
            this.modalRejected = false;
            this.modalMonfirmationRejected = true;
        },

        cancelReject() {
            this.modalMonfirmationRejected = false;
            this.modalRejected = true;
        },

        goToPage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
            }
        },

        formatName(name) {
            let nameParts = name.split(' ').map(part => {
                return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
            });

            return nameParts.join(' ');
        },

        calculateRemainingDays(createdAt) {
            if (!createdAt) {
                console.error("Fecha inválida:", createdAt);
                return "Fecha inválida";
            }

            const formattedCreatedAt = createdAt.replace(/\.\d{6}Z$/, 'Z');

            const createdDate = new Date(formattedCreatedAt);

            if (isNaN(createdDate.getTime())) {
                console.error("Fecha inválida:", formattedCreatedAt);
                return "Fecha inválida";
            }

            createdDate.setDate(createdDate.getDate() + 35);

            const currentDate = new Date();

            const timeDiff = createdDate - currentDate;

            const remainingDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

            return remainingDays;
        },
        showAlertWarning() {
            this.showAlert = true;

            setTimeout(() => {
                this.showAlert = false;
            }, 10000);

        },

    },

    watch: {
        value() {
            this.currentPage = 1;
        },
        filteredPDVs() {
            if (this.currentPage > this.totalPages) {
                this.currentPage = this.totalPages || 1;
            }
        }
    }

}
</script>
